import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Boton from '../../components/Boton'
import BuscadorProveedor from '../../components/BuscadorProveedor'
import { npApi } from '../../api/compras'
import { fmtFecha } from '../../utils/fecha'
import { colors, text, font } from '../../design/tokens'
import { mensajeError, hoverFila, st } from '../emp900/_helpers'
import { Badge } from '../emp900/_comun'
import { NP_ESTADOS, NP_ESTADO_LABEL, NP_ESTADO_TONO, fmtMoneda } from './_np'
import { useStoredState } from '../../hooks/useStoredState'

/**
 * COMPRAS → Pedidos → Consultas. Todos los pedidos con filtros; la fila abre
 * el detalle.
 */
export default function PedidosConsultaPage() {
  const navigate = useNavigate()
  const [filtros, setFiltros] = useStoredState('lgr.filtros.np', { estado: '', abiertos: false, q: '' })
  const [proveedor, setProveedor] = useState(null)
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const cargar = useCallback(async () => {
    setLoading(true)
    try {
      const { data } = await npApi.listar({ estado: filtros.estado || undefined, abiertos: filtros.abiertos ? 1 : undefined, q: filtros.q || undefined, proveedor_id: proveedor?.id || undefined })
      setRows(data.pedidos || []); setError('')
    } catch (e) { setError(mensajeError(e)) } finally { setLoading(false) }
  }, [filtros.estado, filtros.abiertos, filtros.q, proveedor])
  useEffect(() => { cargar() }, [cargar])
  const set = (k, v) => setFiltros(f => ({ ...f, [k]: v }))

  const cols = ['Número', 'Fecha', 'Proveedor', 'Nº prov.', 'Entrega', 'Renglones', 'Saldo (u.)', 'Total', 'Estado']
  return (
    <div>
      <div style={st.header}>
        <h2 style={st.title}>Consultas de pedidos</h2>
        <div style={st.acciones}><Boton variante="primary" onClick={() => navigate('/compras/pedidos/ingreso')}>+ Ingreso de pedido</Boton></div>
      </div>
      <p style={st.sub}>Todos los pedidos a proveedores. Click en la fila para ver el detalle, el seguimiento renglón por renglón y las acciones (emitir, enviar, reporte).</p>

      <div style={st.filtros}>
        <input style={{ ...st.input, maxWidth: 220 }} placeholder="Número…" value={filtros.q} onChange={e => set('q', e.target.value)} />
        <div style={{ minWidth: 320, flex: 1 }}><BuscadorProveedor value={proveedor} onChange={setProveedor} placeholder="Proveedor…" /></div>
        <select style={{ ...st.input, maxWidth: 200 }} value={filtros.estado} onChange={e => set('estado', e.target.value)}>
          <option value="">Todos los estados</option>
          {NP_ESTADOS.map(e => <option key={e} value={e}>{NP_ESTADO_LABEL[e]}</option>)}
        </select>
        <label style={st.check}><input type="checkbox" checked={!!filtros.abiertos} onChange={e => set('abiertos', e.target.checked)} /> Solo con saldo pendiente</label>
        <Boton variante="ghost" sm onClick={() => { setFiltros({ estado: '', abiertos: false, q: '' }); setProveedor(null) }}>Limpiar</Boton>
      </div>

      <div style={st.tableWrap}>
        <table style={st.table}>
          <thead><tr>{cols.map(h => <th key={h} style={{ ...st.th, ...(['Saldo (u.)', 'Total'].includes(h) ? { textAlign: 'right' } : {}) }}>{h}</th>)}</tr></thead>
          <tbody>
            {loading && rows.length === 0 ? <tr><td colSpan={cols.length} style={st.empty}>Cargando…</td></tr>
              : error ? <tr><td colSpan={cols.length} style={st.empty}>{error}</td></tr>
                : rows.length === 0 ? <tr><td colSpan={cols.length} style={st.empty}>No hay pedidos con ese filtro.</td></tr>
                  : rows.map(p => (
                    <tr key={p.id} style={st.trClick} {...hoverFila} onClick={() => navigate(`/compras/pedidos/${p.id}`)} title="Ver el pedido">
                      <td style={st.tdMono}>{p.numero}{p.reemplaza_a_id ? <div style={{ fontFamily: font.sans, fontWeight: 400, fontSize: text.sec, color: colors.textMeta }}>versión nueva</div> : null}</td>
                      <td style={st.tdFecha}>{fmtFecha(p.fecha)}</td>
                      <td style={st.td}>{p.proveedor_nombre}{p.condicion_pago ? <div style={{ fontSize: text.sec, color: colors.textMeta }}>{p.condicion_pago}</div> : null}</td>
                      <td style={st.tdMono}>{p.numero_pedido_proveedor || '—'}</td>
                      <td style={st.tdFecha}>{p.fecha_entrega ? fmtFecha(p.fecha_entrega) : '—'}</td>
                      <td style={st.td}><span style={{ fontVariantNumeric: 'tabular-nums' }}>{p.lineas_completas ?? 0}/{p.lineas ?? 0}</span><span style={{ color: colors.textMeta, fontSize: text.sec }}> completos</span></td>
                      <td style={st.tdImporte}>{p.saldo_unidades != null ? Number(p.saldo_unidades).toLocaleString('es-AR') : '—'}</td>
                      <td style={st.tdImporte}>{fmtMoneda(p.total, p.moneda || 'ARS')}</td>
                      <td style={st.td}><Badge tono={NP_ESTADO_TONO[p.estado] || 'neutro'}>{NP_ESTADO_LABEL[p.estado] || p.estado}</Badge></td>
                    </tr>
                  ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
